// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
import Swiper from "../../node_modules/swiper/js/swiper";

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-fv", {
  allowTouchMove: true,
  loop: true,
  speed: 3000,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      spaceBetween: 30,
    },
  },
});

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-container-nonstop-slide .swiper-container", {
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 25,
  initialSlide: 2,
  loop: true,
  speed: 7500,
  allowTouchMove: false,
  autoplay: {
    enabled: true,
    delay: 1,
  },
  breakpoints: {
    767: {
      spaceBetween: 30,
    },
  },
});

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-information", {
  slidesPerView: "auto",
  spaceBetween: 15,
  centeredSlides: true,
  allowTouchMove: true,
  slideToClickedSlide: true,

  breakpoints: {
    768: {
      slideToClickedSlide: false,
      slidesPerView: 1,
      spaceBetween: 40,
      allowTouchMove: false,
    },
  },
});

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-psychologist", {
  slidesPerView: "auto",
  spaceBetween: 15,
  centeredSlides: true,
  allowTouchMove: true,
  loop: true,
  slideToClickedSlide: true,

  breakpoints: {
    768: {
      slideToClickedSlide: false,
      slidesPerView: 3,
      spaceBetween: 10,
      allowTouchMove: false,
      loop: false,
      initialSlide: 1,
    },

    991: {
      slidesPerView: 3,
      spaceBetween: 40,
      allowTouchMove: false,
      loop: false,
      initialSlide: 1,
    },
  },
});
